import Vue from 'vue';
import Router from 'vue-router';

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');

// Views
const Dashboard = () => import('@/views/Dashboard');

const Login = () => import('@/views/Pages/Login');
const PasswordForgot = () => import('@/views/Pages/PasswordReset/PasswordForgot');
const PasswordReset = () => import('@/views/Pages/PasswordReset/PasswordReset');

const Orders = () => import('@/views/Orders/Orders');
const OrderCreate = () => import('@/views/Orders/OrderCreate');
const OrderUpdate = () => import('@/views/Orders/OrderUpdate/OrderUpdate');

const Invoices = () => import('@/views/Invoices/Standard/Invoices');
const InvoiceUpdate = () => import('@/views/Invoices/Standard/InvoiceUpdate');
const InvoiceCreate = () => import('@/views/Invoices/Standard/InvoiceCreate');

const AdvanceInvoices = () => import('@/views/Invoices/Advance/AdvanceInvoices');
const AdvanceInvoiceUpdate = () => import('@/views/Invoices/Advance/AdvanceInvoiceUpdate');
const AdvanceInvoiceCreate = () => import('@/views/Invoices/Advance/AdvanceInvoiceCreate');

const Users = () => import('@/views/Users/Users');
const UserCreate = () => import('@/views/Users/UserCreate');
const UserUpdate = () => import('@/views/Users/UserUpdate/UserUpdate');

const Roles = () => import('@/views/Roles/Roles');
const RoleCreate = () => import('@/views/Roles/RoleCreate');
const RoleUpdate = () => import('@/views/Roles/RoleUpdate');

const Structures = () => import('@/views/Structures/Structures');
const StructureCreate = () => import('@/views/Structures/StructureCreate');
const StructureUpdate = () => import('@/views/Structures/StructureUpdate/StructureUpdate');

const AuditLogs = () => import('@/views/AuditLogs');
const SyncAuditLogs = () => import('@/views/SyncAuditLogs');
const Notifications = () => import('@/views/Notifications/Notifications');
const ProcurementScheme = () => import('@/views/ProcurementScheme/ProcurementScheme');

Vue.use(Router);

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: { name: 'Dashboard' },
      name: null,
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          meta: { label: 'dashboard_nav_title' },
          component: Dashboard
        },
        {
          path: 'orders',
          name: 'Orders',
          meta: { label: 'orders_nav_title' },
          redirect: { name: 'Orders', params: { page: 1 } },
          component: {
            render(c) {
              return c('router-view');
            }
          },
          children: [
            {
              path: 'list/:page',
              name: 'Orders',
              meta: { label: 'list' },
              props: true,
              component: Orders
            },
            {
              path: 'create',
              name: 'OrderCreate',
              meta: { label: 'order_create_nav_title' },
              component: OrderCreate
            },
            {
              path: 'update/:id/:tab?/:page?',
              name: 'OrderUpdate',
              meta: { label: 'order_update_nav_title' },
              props: true,
              component: OrderUpdate
            },
          ]
        },
        {
          path: 'invoices',
          name: null,
          component: {
            render(c) {
              return c('router-view');
            }
          },
          children: [
            {
              path: 'standard',
              name: null,
              meta: { label: 'invoices_nav_title' },
              redirect: { name: 'Invoices', params: { page: 1 } },

              component: {
                render(c) { return c('router-view'); }
              },

              children: [
                {
                  path: 'list/:page/:viewPending?',
                  name: 'Invoices',
                  meta: { label: 'list' },
                  props: true,
                  component: Invoices,
                },
                {
                  path: 'create',
                  name: 'InvoiceCreate',
                  meta: { label: 'invoice_create_nav_title' },
                  component: InvoiceCreate
                },
                {
                  path: 'update/:id/:tab?/:page?',
                  name: 'InvoiceUpdate',
                  meta: { label: 'invoice_update_nav_title' },
                  props: true,
                  component: InvoiceUpdate
                },
              ]
            },

            {
              path: 'advance',
              name: null,
              meta: { label: 'advance_invoices_nav_title' },
              redirect: { name: 'AdvanceInvoices', params: { page: 1 } },

              component: {
                render(c) { return c('router-view'); }
              },

              children: [
                {
                  path: 'list/:page/:viewPending?',
                  name: 'AdvanceInvoices',
                  meta: { label: 'list' },
                  props: true,
                  component: AdvanceInvoices,
                },
                {
                  path: 'create',
                  name: 'AdvanceInvoiceCreate',
                  meta: { label: 'advance_invoice_create_nav_title' },
                  component: AdvanceInvoiceCreate
                },
                {
                  path: 'update/:id/:tab?/:page?',
                  name: 'AdvanceInvoiceUpdate',
                  meta: { label: 'advance_invoice_update_nav_title' },
                  props: true,
                  component: AdvanceInvoiceUpdate
                },
              ]
            },
          ]
        },

        {
          path: 'administration',
          name: null,
          component: {
            render(c) {
              return c('router-view');
            }
          },
          children: [
            {
              path: 'users',
              name: null,
              meta: { label: 'users_nav_title' },
              redirect: { name: 'Users', params: { page: 1 } },

              component: {
                render(c) { return c('router-view'); }
              },

              children: [
                {
                  path: 'list/:page',
                  name: 'Users',
                  meta: { label: 'list' },
                  props: true,
                  component: Users,
                },
                {
                  path: 'create',
                  name: 'UserCreate',
                  meta: { label: 'user_create_nav_title' },
                  component: UserCreate
                },
                {
                  path: 'update/:id',
                  name: 'UserUpdate',
                  meta: { label: 'user_update_nav_title' },
                  props: true,
                  component: UserUpdate
                },
              ]
            },
            {
              path: 'roles',
              name: null,
              meta: { label: 'roles_nav_title' },
              redirect: { name: 'Roles', params: { page: 1 } },

              component: {
                render(c) { return c('router-view'); }
              },

              children: [
                {
                  path: 'list/:page',
                  name: 'Roles',
                  meta: { label: 'list' },
                  props: true,
                  component: Roles,
                },
                {
                  path: 'create',
                  name: 'RoleCreate',
                  meta: { label: 'role_create_nav_title' },
                  component: RoleCreate
                },
                {
                  path: 'update/:id',
                  name: 'RoleUpdate',
                  meta: { label: 'role_update_nav_title' },
                  props: true,
                  component: RoleUpdate
                },
              ]
            },
            {
              path: 'structures',
              name: null,
              meta: { label: 'structures_nav_title' },
              redirect: { name: 'Structures', params: { page: 1 } },

              component: {
                render(c) { return c('router-view'); }
              },

              children: [
                {
                  path: 'list/:page',
                  name: 'Structures',
                  meta: { label: 'list' },
                  props: true,
                  component: Structures,
                },
                {
                  path: 'create',
                  name: 'StructureCreate',
                  meta: { label: 'structure_create_nav_title' },
                  component: StructureCreate
                },
                {
                  path: 'update/:id',
                  name: 'StructureUpdate',
                  meta: { label: 'structure_update_nav_title' },
                  props: true,
                  component: StructureUpdate
                },
              ]
            },
            {
              path: 'audit-logs',
              name: null,
              meta: { label: 'audit_logs_nav_title' },
              redirect: { name: 'AuditLogs', params: { page: 1 } },

              component: {
                render(c) { return c('router-view'); }
              },

              children: [
                {
                  path: 'list/:page',
                  name: 'AuditLogs',
                  meta: { label: 'list' },
                  props: true,
                  component: AuditLogs,
                },
              ]
            },
            {
              path: 'sync-audit-logs',
              name: null,
              meta: { label: 'sync_audit_logs_nav_title' },
              redirect: { name: 'SyncAuditLogs', params: { page: 1 } },

              component: {
                render(c) { return c('router-view'); }
              },

              children: [
                {
                  path: 'list/:page',
                  name: 'SyncAuditLogs',
                  meta: { label: 'list' },
                  props: true,
                  component: SyncAuditLogs,
                },
              ]
            },
            {
              path: 'notifications',
              name: null,
              meta: { label: 'notifications_nav_title' },
              redirect: { name: 'Notifications', params: { page: 1 } },

              component: {
                render(c) { return c('router-view'); }
              },

              children: [
                {
                  path: 'list/:page',
                  name: 'Notifications',
                  meta: { label: 'list' },
                  props: true,
                  component: Notifications,
                },
              ]
            },
            {
              path: 'procurement-scheme',
              name: null,
              meta: { label: 'procurement_scheme_nav_title' },
              redirect: { name: 'ProcurementScheme', params: { page: 1 } },

              component: {
                render(c) { return c('router-view'); }
              },

              children: [
                {
                  path: 'list/:page/:categoryId?',
                  name: 'ProcurementScheme',
                  meta: { label: 'list' },
                  props: true,
                  component: ProcurementScheme,
                },
              ]
            },
          ]
        }
      ]
    },

    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/forgot-password',
      name: 'PasswordForgot',
      component: PasswordForgot
    },
    {
      path: '/reset-password',
      props: true,
      name: 'PasswordReset',
      component: PasswordReset
    },
  ]
});

router.beforeEach((to, from, next) => {
  if (to.name === 'Login' && from.name && from.name !== 'Login'
    && from.name !== 'PasswordForgot'
    && from.name !== 'PasswordReset') {
    sessionStorage.setItem('redirectPath', from.path);
  }
  next();
});

export default router;
